/**
 * Creates a shallow copy of the provided data.
 *
 * @param {any} data - The data to be shallow copied. Can be of any type,
 *                     and the function handles both arrays and objects.
 * @returns {any} - A shallow copy of the provided data. If the input is an
 *                  array, a new array with the same elements is returned.
 *                  If the input is an object, a new object with the same
 *                  properties is returned.
 */
export const shallowCopy1 = (data: any): any => {
  let copiedValue;

  if (Array.isArray(data)) {
    copiedValue = [];
    for (let i = 0; i < data.length; i++) {
      copiedValue.push(data[i]);
    }
  } else {
    copiedValue = { ...data };
  }

  return copiedValue;
};

/**
 * Creates a deep copy of the provided data.
 *
 * @param {any} data - The data to be deep copied. Can be of any type,
 *                     and the function handles both arrays and objects.
 * @returns {any} - A deep copy of the provided data. If the input is an
 *                  array, a new array with the same elements is returned.
 *                  If the input is an object, a new object with the same
 *                  properties is returned.
 */
export const shallowCopy = (data: any): any => {
  if (data === null || typeof data !== "object") {
    return data; // Return the value if data is not an object
  }

  let copiedValue;

  if (Array.isArray(data)) {
    copiedValue = [];
    for (let i = 0; i < data.length; i++) {
      copiedValue.push(shallowCopy(data[i]));
    }
  } else {
    copiedValue = {};
    for (const key in data) {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(key)) {
        (copiedValue as any)[key] = shallowCopy(data[key]);
      }
    }
  }

  return copiedValue;
};
